import {Component, OnDestroy, OnInit, inject} from '@angular/core';
import {Subscription} from "rxjs";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {ActivatedRoute} from "@angular/router";
import {CustomerService} from "../../../shared/services/customer.service";
import {RouterService} from "../../../shared/services/router.service";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {AsyncPipe, NgOptimizedImage} from "@angular/common";
import {FormInputComponent} from "../../../shared/elements/form-input/form-input.component";
import {LanguageService} from "../../../shared/services/language.service";
import {LoadingService} from "../../../shared/services/loading.service";
import {LayoutService} from "../../../shared/services/layout.service";
import {FormButtonComponent} from "../../../shared/elements/form-button/form-button.component";
import {LinkComponent} from "../../../shared/elements/link/link.component";
import {HeadlineComponent} from "../../../shared/elements/headline/headline.component";
import {ContentComponent} from "../../../shared/elements/content/content.component";
import {Router} from "@angular/router";
import {TokenService} from '../../../shared/services/token.service';
import {NgSrcImageErrorDirective} from '../../../shared/directives/ng-src-image-error.directive';
import {ToasterService} from '../../../shared/services/toaster.service';

@Component({
    selector: 'app-customer',
    imports: [
        FormInputComponent,
        NgOptimizedImage,
        ReactiveFormsModule,
        TranslatePipe,
        AsyncPipe,
        FormButtonComponent,
        LinkComponent,
        HeadlineComponent,
        ContentComponent,
        NgSrcImageErrorDirective
    ],
    providers: [
        TranslatePipe
    ],
    templateUrl: './customer.component.html',
    styleUrl: './customer.component.scss'
})
export class CustomerComponent implements OnInit, OnDestroy {
  public languageService: LanguageService = inject(LanguageService);
  public loadingService: LoadingService = inject(LoadingService);
  public layoutService: LayoutService = inject(LayoutService);
  public router: Router = inject(Router);
  private customerService: CustomerService = inject(CustomerService);
  private toasterService: ToasterService = inject(ToasterService);
  private formBuilder: FormBuilder = inject(FormBuilder);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private routerService: RouterService = inject(RouterService);
  private tokenService: TokenService = inject(TokenService);


  public customerForm: FormGroup = this.formBuilder.group({
    customer: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(45)]]
  });
  private subscriptions: Subscription[] = [];

  public ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.get('resetCustomer') === 'true') {
      return;
    }

    const customerKey = this.customerService.getStoredCustomerKey(this.route.snapshot.params);
    if (customerKey) {
      this.onCustomerLogin(customerKey);
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  public onCustomerLogin(customerKey: string | null): void {
    const normalizedCustomerKey = customerKey?.trim();
    if (!normalizedCustomerKey) return;

    this.subscriptions.push(this.customerService.getPublicCustomerResourceCached(normalizedCustomerKey).subscribe({
      next: (customerPublicResource) => {
        const token = this.route.snapshot.paramMap.get('token');
        if (token) {
          this.tokenService.setToken(token, true);
        }

        this.customerService.setCustomerKey(normalizedCustomerKey);
        this.customerService.setPublicCustomerResource(customerPublicResource);
        this.onCustomerSuccess(normalizedCustomerKey);
      }, error: (error) => {
        this.customerService.resetCustomer();
        this.toasterService.error(this.languageService.getTranslationByKey('ERROR'), error);
      }
    }));

  }
  private onCustomerSuccess(customerKey: string): void {
    const target = this.customerService.hasSsoOptions() && !this.tokenService.hasToken() ? '/auth/sso' : '/auth/login';
    if (this.customerService.redirectToCustomerHost(customerKey, target)) {
      return;
    }

    this.routerService.navigateTo(target);
  }

  public setLanguage(language: string): void {
    this.languageService.setLanguage(language);
  }
}
